export default __webpack_public_path__ + "static/media/google.330a2dc7.svg";